<div
  #toastElement
  [ngClass]="type"
  class="toast my-3"
  role="alert"
  aria-live="polite"
  aria-atomic="true"
  (click)="hide()"
>
  <div class="toast-header">
    <strong class="me-auto">{{ title }}</strong>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="toast"
      aria-label="Close"
    ></button>
  </div>
  <div class="toast-body">
    {{ message }}
  </div>
</div>

<!-- <div
  #toastElement
  class="toast toast-width mt-2"
  [ngClass]="type"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="d-flex justify-content-between align-items-center p-3">
    <div class="toast-body">
      {{ message }}
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="hide()"
    ></button>
  </div>
</div> -->
